// extracted by mini-css-extract-plugin
export default {"contents":"styles_contents__VsBGf","titleArea":"styles_titleArea__l7XRO","txtArea":"styles_txtArea__QEYm4","buttonArea":"styles_buttonArea__7HI7p"};